export default "__VITE_ASSET__BzVrpwo6__"